import { atom } from "recoil"

export type Activity =
  | `dragging`
  | `moving`
  | `panning`
  | `resizing`
  | `rotating`
  | `stopping`

export const activityState = atom<Activity | null>({
  key: `activity`,
  default: null,
})
